//AuthContext.js
import React, { createContext, useState, useEffect, useContext } from "react";
import { loginUser } from "./utils/api"; // Ensure correct path

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || null);
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });



  useEffect(() => {
    if (token && user) {
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    }
  }, [token, user]);

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
  
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
  }, []);
  

  // ✅ Ensure `userId` exists in `user`
  const login = async (credentials, navigate) => {
    try {
      const data = await loginUser(credentials);
      
      // ✅ Make sure to include `userId`
      setToken(data.token);
      setUser({
        userId: data.userId,  // ✅ Ensure this exists
        name: data.name,
        fullname: data.fullName,
        role: data.role,
        email: data.email,
        carehome: data.carehome,
      });
  
      console.log("✅ AuthContext - User logged in:", data); // Debugging
      console.log("HERE", data.fullName);
      navigate("/dashboard");
      return data;
    } catch (error) {
      console.error("🔴 Login failed:", error);
      alert("Login failed: " + error.message);
      return null;
    }
  };

  console.log("🔵 AuthContext - Initial User:", user); // Debugging
  // console.log("🔵 AuthContext - Initial Token:", token); // Debugging
  

  const logout = (navigate) => {
    console.log("🔴 AuthContext - Logging out");
    setToken(null);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/");
  };

  return (
    <AuthContext.Provider value={{ token, user, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export default AuthContext;
